import styled, { css } from 'styled-components';
import { Button as _Button } from '@/components/UI/Button/Button';
import { getMaskIconStyles } from '@/styles/helpers';

export const Button = styled(_Button)<{ $hasIcon?: boolean }>`
  white-space: nowrap;

  ${({ $hasIcon }) =>
    $hasIcon &&
    css`
      &::before {
        content: '';
        display: block;
        margin-right: 5px;
        background-color: ${({ theme }) => theme.palette.secondary.labels};

        ${getMaskIconStyles('language.svg')};
      }
    `}

  &:hover {
    & p {
      color: ${({ theme }) => theme.palette.brand.main};
    }

    &::before {
      background-color: ${({ theme }) => theme.palette.brand.main};
    }
  }
`;
